module.exports = __webpack_public_path__ + "img/Wp_2076.5620206d.png";